import React, { useEffect, useState } from "react";
import api from "@/lib/api";

export default function SponsorStrip({ variant = "footer", testId = "sponsor-strip" }) {
  const [sponsors, setSponsors] = useState([]);
  useEffect(() => {
    api.get("/content").then((r) => setSponsors(r.data?.sponsors || [])).catch(() => {});
  }, []);
  const shown = sponsors.filter((s) => s.logo);
  if (!shown.length) return null;
  const img = (v) => (v.startsWith("http") ? v : `${process.env.REACT_APP_BACKEND_URL}${v}`);
  const headline = shown.filter((s) => s.tier === "headline");
  const supporting = shown.filter((s) => s.tier !== "headline");

  const Logo = ({ s, i, size }) => {
    const el = <img src={img(s.logo)} alt={s.name} className={`${size} w-auto object-contain opacity-70 hover:opacity-100 transition-opacity`} data-testid={`sponsor-logo-img-${i}`} />;
    return s.url ? <a key={i} href={s.url} target="_blank" rel="noreferrer" data-testid={`sponsor-link-${i}`}>{el}</a> : <span key={i}>{el}</span>;
  };

  let idx = 0;
  return (
    <div className={variant === "footer" ? "mt-10 pt-8 border-t border-white/10" : "mt-4"} data-testid={testId}>
      <div className="text-slate-500 text-[10px] uppercase tracking-[0.3em] text-center mb-5">Our Partners</div>
      {headline.length > 0 && (
        <div className="flex flex-wrap items-center justify-center gap-x-12 gap-y-6 mb-6">
          {headline.map((s) => <Logo key={idx} s={s} i={idx++} size="h-16 md:h-20" />)}
        </div>
      )}
      {supporting.length > 0 && (
        <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-6">
          {supporting.map((s) => <Logo key={idx} s={s} i={idx++} size="h-9 md:h-11" />)}
        </div>
      )}
    </div>
  );
}
